import React from 'react';
import { ErrorMessage } from 'formik';
import { Typography } from '@mui/material';

const TranslatedErrorMessage = ({ name }) => (
  <ErrorMessage name={name}>
    {(msg) => (
      <Typography style={{ color: 'red', fontSize: '0.875rem' }}>
        {msg}
      </Typography>
    )}
  </ErrorMessage>
);

export default TranslatedErrorMessage;
